const dashboardNorwegian = {
  greeting: {
    morning: "God morgen",
    afternoon: "God ettermiddag",
    evening: "God kveld"
  },
  recentActivity: {
    title: "Nylig Aktivitet",
    empty: "Ingen aktivitet å vise ennå"
  },
  notifications: {
    title: "Varsler",
    loading: "Laster varsler...",
    newPost: "Nytt LinkedIn-innlegg klart!",
    seeAll: "Se alle {count} innlegg",
    empty: "Ingen varsler å vise"
  }
};

export default dashboardNorwegian; 